import { CustomerAPI } from 'api'

export const fetchUser = () => {
    return CustomerAPI.get("/users/me")
        .then(response => response.data)
}